import React from 'react'

import { TabPills } from '@components/common'
import { Button, ModalBox, useModalContext } from '@fourthwall/components'

import type { Tab } from './NewPodcastModal.types'
import { ExistingPodcastFields } from './components/ExistingPodcastFields/ExistingPodcastFields'
import { NewPodcastFields } from './components/NewPodcastFields/NewPodcastFields'
import { useNewPodcastModalContext } from './hooks/useNewPodcastModalContext'
import { NewPodcastModalProvider } from './providers/NewPodcastModalProvider'

const NewPodcastModalContent = () => {
  const modal = useModalContext()
  const { tab, setTab, existingPodcastForm, newPodcastForm, preview, isLoading } =
    useNewPodcastModalContext()

  return (
    <ModalBox
      title="Where do you want your members-only audio to appear on Spotify?"
      buttons={[
        <Button label="Cancel" onClick={modal.close} />,
        <Button
          label="Continue"
          appearance="primary"
          loading={isLoading}
          onClick={() => {
            if (tab === 'existing') {
              if (preview.error) return
              if (preview.data?.hostedOnSpotify) return

              existingPodcastForm.submitForm()
            } else {
              newPodcastForm.submitForm()
            }
          }}
        />,
      ]}
      onClose={modal.close}
    >
      <TabPills
        options={[
          { label: ' Add to your existing podcast', value: 'existing' satisfies Tab },
          { label: 'Create a new podcast', value: 'new' satisfies Tab },
        ]}
        value={tab}
        onChange={isLoading ? () => {} : setTab}
      />
      {tab === 'existing' ? <ExistingPodcastFields /> : <NewPodcastFields />}
    </ModalBox>
  )
}

export const NewPodcastModal = () => (
  <NewPodcastModalProvider>
    <NewPodcastModalContent />
  </NewPodcastModalProvider>
)
